import { useMutation } from 'react-query';
import request from '../../../helpers/request';

const updateListNotAnsweredCalls = async (callerId) => {
  return await request.post(
    `/Phone/update_list_not_answered_calls?callerId=${callerId}`,
    null,
    'Не удалось обновить непринятый звонок'
  );
};

const useUpdateListNotAnsweredCalls = () =>
  useMutation(updateListNotAnsweredCalls);

export default useUpdateListNotAnsweredCalls;
